import React from 'react';
import { useParams } from 'react-router-dom';
import PublicatonForm from './PublicationForm';
import { useGetPublicationQuery } from '../../../../redux/apiSlice';

const EditPublication = () => {
  const { id } = useParams();
  const { data: publicationData, isError, isLoading } = useGetPublicationQuery(id);

  const errorMsg = isError ? 'Error while getting publication information.Try again later' : '';
  return (
    <div>
      {isLoading && <p>Loading...</p>}
      {isError && <p>{errorMsg}</p>}
      <PublicatonForm publicationData={publicationData} />
    </div>
  );
};

export default EditPublication;
